import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './power-bi-constants';
import * as actions from './power-bi-actions';

export function* fetchPowerBiReports(action) {
  try {
    const results = yield call(callApi, {
      endpoint: '/reports',
      options: {
        method: 'GET',
        errorMessage: 'Could not fetch powerBI reports',
        retryAction: action,
      },
    });

    yield put(actions.fetchPowerBiReportsSuccess(results));
  } catch (err) {
    yield put(actions.fetchPowerBiReportsFailure(err));
  }
}

function* watchFetchPowerBiReports() {
  yield takeLatest(types.FETCH_POWER_BI_REPORTS_REQUEST, fetchPowerBiReports);
}

export default [
  fork(watchFetchPowerBiReports),
];
